var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.optionsList, function (item) {
      return _c("SidebarButton", {
        key: "complSettingsSidebar" + item.componentName,
        attrs: {
          "display-value": item.displayValue,
          "component-name": item.componentName,
          selected: _vm.isSelected(item.componentName),
          "event-name": _vm.eventName,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }